export default __webpack_public_path__ + "static/Theposterboyofzero-wasteliving-481a8d57d4511e5b488aac903d4af6ed.jpg";